export const c_progress_stepper_m_horizontal_m_compact_GridTemplateColumns = {
  "name": "--pf-c-progress-stepper--m-horizontal--m-compact--GridTemplateColumns",
  "value": "repeat(auto-fill, 1.75rem)",
  "var": "var(--pf-c-progress-stepper--m-horizontal--m-compact--GridTemplateColumns)"
};
export default c_progress_stepper_m_horizontal_m_compact_GridTemplateColumns;